import React from 'react';

const PageFooter = (props) => {
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let classDescription = props? props.classDescription : ""; 
    return(
        <div>
            <p className={classDescription}>&copy; {currentYear} <strong>Touchless Hygiene Systems</strong></p>
        </div>
    )
}
export default PageFooter;